import { Router } from '@angular/router';
import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';

import { Subscription } from 'rxjs';

import { environment } from 'src/environments/environment';
import { AppComponent } from 'src/app/app.component';
import { Usuario } from 'src/app/seguranca/usuario/usuario/usuario.model';
import { UsuarioService } from 'src/app/seguranca/usuario/usuario/usuario.service';
import { Notificacao } from '../notificacao/notificacao.model';
import { AutenticacaoService } from '../../seguranca/autenticacao.service';
import { AutenticacaoGhubService } from 'src/app/homecare/gis/ghub/autenticacao-ghub.service';
import { NotificacaoService } from '../notificacao/notificacao.service';
import { NotificacaoDTO, NotificacaoOperacao } from '../notificacao/notificacao-dto.model';
import { AmbienteService } from '../multi-tenancy/ambiente.service';
import { ReleaseNoteHomeComponent } from 'src/app/seguranca/release-note/components/release-note-home/release-note-home.component';
import { PermissaoNome } from 'src/app/seguranca/perfil-de-acesso/permissao/permissao-nome.enum';
import { ToasterService } from '../framework/toaster/toaster.service';
import { ChaveConfiguracao } from '../multi-tenancy/chave-configuracao.enum';
import { ParametroService } from 'src/app/seguranca/configuracao/parametro/parametro.service';
import { Parametro } from '../multi-tenancy/parametro.model';


@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html',
    styleUrls: ['./app.topbar.component.css']
})
export class AppTopBarComponent implements OnInit, AfterViewInit, OnDestroy {
  usuario: Usuario = new Usuario();

  // notification vars
  notificacoes: Notificacao[];
  notificacaoSubscription: Subscription;

  urlDoFormularioDeFeedback = '';
  arquivoLogoPequena = '';
  isGEEO = false;

  constructor(
      public app: AppComponent
      , private autenticacaoService: AutenticacaoService
      , private autenticacaoGhubService: AutenticacaoGhubService
      , private notificacaoService: NotificacaoService
      , private ambienteService: AmbienteService
      , private router: Router
      , private usuarioService: UsuarioService
      , private toasterService: ToasterService
      , private parametroService: ParametroService
  ) {
      this.notificacoes = new Array<Notificacao>();

      this.subscribeToNotification();
  }

  ngOnInit() {
    this.carregaAmbiente();
    
    this.subscribeToNotification();

    this.procurarUrlDoFormularioDeFeedback();
  }
  
  ngAfterViewInit(): void {
    setTimeout(() => {
      this.usuario = UsuarioService.getUsuarioFromLocalStorage();
      this.isGEEO = this.ambienteService.isGEEO();
    }, 500);
  }

  carregaAmbiente(): void {
    const ambiente = this.ambienteService.getAmbiente();
    if ( ambiente ) {
      this.arquivoLogoPequena = ambiente.getArquivoLogoPequena();
    }
  }

  logout() {
      this.autenticacaoService.logout();
      this.autenticacaoGhubService.logout();

      this.unsubscribeToNotification();
  }

  ngOnDestroy() {
    this.unsubscribeToNotification();
  }

  clickNotificacao(o: Notificacao): void {
    if ( o.getOnClick() ) {
      o.execOnClick();
    }

    setTimeout(() => {
      this.notificacaoService.removerNotificacao(o)
    }, 700);
  }

  subscribeToNotification() {
    if ( !this.notificacaoSubscription ) {
      this.notificacaoSubscription = this.notificacaoService
          .getNotificacaoSubject()
          .subscribe( (o: NotificacaoDTO)  => {
            switch ( o.operacao ) {
              case NotificacaoOperacao.ADICIONAR:
                this.notificacoes.push(o.notificacao);
                break;

              case NotificacaoOperacao.REMOVER:
                // console.log(this.notificacoes);
                this.notificacoes = this.notificacoes.filter(function(value, index, arr) { 
                  return value.getToken() !== o.notificacao.getToken();
                });
                console.log(this.notificacoes);
                break;

              case NotificacaoOperacao.LIMPAR:
                this.notificacoes = [];
                break;                                  
            }
          });      
    }
  }

  unsubscribeToNotification(): void {
    if (this.notificacaoSubscription) {
      this.notificacaoSubscription.unsubscribe();
    }
  }

  abrirManual(): void {
    window.open(environment.url_manual_healthlog, '_blank');
  }

  irParaReleaseNoteHome(): void {
    const temPermissaoPraVerRelease = this.usuarioService.usuarioLogadoTemPermissao(PermissaoNome.ROLE_PESQUISAR_RELEASE_NOTE);
    if ( !temPermissaoPraVerRelease ) {
      this.toasterService.info('O seu usuário não possui esta permissão.');
      return;
    }

    this.router.navigate([ReleaseNoteHomeComponent.releaseNoteHomeUri])
  }

  procurarUrlDoFormularioDeFeedback(): void {
    this.parametroService
        .buscar(ChaveConfiguracao.AMBIENTE, 'URL_FORM_FEEDBACK')
        .subscribe((parametro: Parametro) => {
          if ( parametro ) {
            this.urlDoFormularioDeFeedback = parametro.valor;
          }
        });
  }
}
